import api from './requests';

export default async function getAuth (token) {
  const response = await api.request({
    method: 'get',
    url: '/auth',
    headers: { authorization: token }
  });
  return response.data;
}
